import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";

interface GraphDetails {
    allData: (data: any[]) => void;
}

const MentalReadinessGraph: React.FC<GraphDetails> = ({ allData }) => {

    const [isLoading, setIsLoading] = useState(false);
    const [readinessData, setReadinessData] = useState<any>([]);

    useEffect(() => {
        async function fetchMetrics() {
            setIsLoading(true);
            setReadinessData(allData.mentalReadiness || []);

            setIsLoading(false);
        }
        fetchMetrics();
    }, [allData]);

    // Helper for date → DD-MM-YYYY
    const formatDate = (date) => {
        const d = new Date(date);
        const day = String(d.getDate()).padStart(2, "0");
        const month = String(d.getMonth() + 1).padStart(2, "0");
        const year = String(d.getFullYear()).slice(-2);
        return `${day}-${month}-${year}`;
    };

    // If data not loaded, return nothing
    if (!readinessData.mentalReadiness || !readinessData.mentalReadiness_avg || !readinessData.x_axis) {
        return <div className="text-center">{readinessData.error}</div>;
    }
    // Safe mapping (prevents map undefined error)

    const readinessValues = Array.isArray(readinessData.mentalReadiness) ? readinessData.mentalReadiness.map(Number) : [];
    const readinessAvgValues = Array.isArray(readinessData.mentalReadiness_avg) ? readinessData.mentalReadiness_avg.map(Number) : [];
    const labelMap = Array.isArray(readinessData.metricscale)
        ? readinessData.metricscale.reduce((acc: Record<string, string>, item: any) => {
            const [key, value] = Object.entries(item)[0];
            // acc[key] = value as string;
            acc[Number(key).toString()] = value as string;
            return acc;
        }, {})
        : {};


    const start = new Date(readinessData.x_axis.min);
    const oneDay = 24 * 60 * 60 * 1000;
    const dates = Array.isArray(readinessData.x_axis) ? readinessData.x_axis : [];

    // Create series with STRING DATES
    const barData = readinessValues.map((value, i) => ({
        // x: formatDate(new Date(start.getTime() + i * oneDay)),
        x: formatDate(dates[i]),
        y: value
    }));

    const lineData = readinessAvgValues.map((value, i) => ({
        // x: formatDate(new Date(start.getTime() + i * oneDay)),
        x: formatDate(dates[i]),
        y: value
    }));

    const optionsBar = {
        chart: {
            type: "line",
            stacked: false,
            height: 350,
            toolbar: { show: false }
        },

        series: [
            {
                name: "Mental Readiness",
                type: "bar",
                data: barData,
                color: "#1eb0d5"
            },
            {
                name: "Mental Readiness Average",
                type: "line",
                data: lineData,
                color: "#24c80b"
            }
        ],

        plotOptions: {
            bar: {
                columnWidth: "40%",
                borderRadius: 4,
                dataLabels: { enabled: false }
            }
        },

        stroke: {
            width: [0, 3],
            curve: "smooth"
        },

        xaxis: {
            type: "category",   // IMPORTANT → shows date as string
            labels: {
                rotate: 0,
                style: { colors: "#777" }
            }
        },

        yaxis: {
            min: -2,
            max: 2,
            tickAmount: 4,
            labels: {
                // formatter: (val: number) => val.toFixed(0),
                formatter: (val: number) => {
                    const key = Math.round(val).toString();

                    return labelMap[key] || "";
                },
                style: { colors: "#777" }
            }
        },

        dataLabels: { enabled: false },

        legend: { show: false }
    };

    return (
        <div id="bar">
            <ReactApexChart
                options={optionsBar}
                series={optionsBar.series}
                type="line"
                height={250}
                width="100%"
            />
        </div>
    );
};

export default MentalReadinessGraph;
